import axiosInstance from './axiosInstance';
import { API_CONFIG } from './config';
import { getRequesterId } from '../utils/storageManager';
import {
  GenerateLoopRequest,
  GenerateLoopResponse,
  GetLoopDetailsRequest,
  GetLoopDetailsResponse,
  GetRequestDetailsResponse,
} from './types';

export const loopService = {
  /**
   * Generate an optimized loop/route
   */
  generateLoop: async (
    requestData: GenerateLoopRequest
  ): Promise<GenerateLoopResponse> => {
    try {
      const requesterId = getRequesterId();
      const response = await axiosInstance.post(
        API_CONFIG.ENDPOINTS.GENERATE_LOOP, {},
        {
          params: {
            requesterId,
            date_time: requestData.date_time,
            driverId: requestData.driverId,
            driverLat: requestData.driverLat,
            driverLong: requestData.driverLong,
            vehicleId: requestData.vehicleId,
            vehicleLat: requestData.vehicleLat,
            vehicleLong: requestData.vehicleLong,
          },
        }
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      const message = error?.response?.data?.message ?? error?.response?.data ?? error?.message ?? null;
      return ({ data: typeof message === 'string' ? message : 'Request failed', status: error?.response?.status ?? 500 })
    }
  },

  /**
   * Get request details after loop generation
   */
  getRequestDetails: async (): Promise<GetRequestDetailsResponse> => {
    try {
      const requesterId = getRequesterId();
      const response = await axiosInstance.get(
        API_CONFIG.ENDPOINTS.GET_REQUEST_DETAILS,
        {
          params: { requesterId },
        }
      );
      return { status: response.status, data: response.data?.data ?? response.data };
    } catch (error: any) {
      return { status: error?.response?.status ?? 500, data: undefined };
    }
  },

  /**
   * Get loop details for a specific vehicle
   */
  getLoopDetails: async (
    requestData: GetLoopDetailsRequest
  ): Promise<GetLoopDetailsResponse> => {
    try {
      const requesterId = getRequesterId();
      const response = await axiosInstance.get(
        API_CONFIG.ENDPOINTS.GET_LOOP_DETAILS,
        {
          params: {
            requesterId,
            vehicleId: requestData.vehicleId,
          },
        }
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return { data: error?.response?.data ?? null, status: error?.response?.status ?? 500 };
    }
  },
};
